import { TextField, styled } from '@mui/material';

const CustomTextField = styled(TextField)`
  & .Mui-error input {
    color: ${({ theme }) => theme.palette.error.main};
  }
`;

export default CustomTextField;
